import { useState, useEffect } from 'react';

import '../../styles/popup.css';

import TextField from '@mui/material/TextField';

const ManageForm = ({ type = "Default", onSubmit, editingItem, onClose }) => {
    const [name, setName] = useState('');

    useEffect(() => {
        if (editingItem) {
            setName(editingItem.vendor || editingItem.type || '');
        }
    }, [editingItem]);

    const handleSubmit = () => {
        if (name.trim() === '') return;
        onSubmit({ name, id: editingItem?._id });
        setName('');
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-popup" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>
                <h2 className="text-2xl text-black">{editingItem ? `Edit` : `Add`} {type}</h2>
                <TextField
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    label={`${type} Name`}
                    variant="outlined"
                />
                <button
                    className="button"
                    style={{ marginTop: '30px', marginBottom: '10px' }}
                    onClick={handleSubmit}
                >
                    {editingItem ? `Edit` : `Add`} {type}
                </button>
            </div>
        </div>
    );
};

export default ManageForm;
